import { useState, useEffect } from "react"
import Badge from 'react-bootstrap/Badge';
import toast from "react-hot-toast";
import moment from 'moment'

import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import LoaderIcon from 'react-loading-icons'
import api from "../components/api";


import TextInput from '../components/TextInput';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from "date-fns/locale/pt-BR";


interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,


}

interface iCorretor {

    corretor_id: number,
    tipoJuridico: string,
    nome: string,
    nomeFantasia: string,
    razaoSocial: string,
    cpf: string,
    cnpj: string,

}

interface iDados {

    bloqueada: string,
    cpfUsuarioCriador: string,
    dataEmissao: string,
    dataInicio: string,
    dataVencimento: string,
    dataVencimentoIndeterminado: string,
    dias: number,
    emissao_id: number,
    fiscal: string,
    garantia: string,
    minuta: string,
    multa: string,
    pago: string,
    percentualComissao: number | undefined,
    pin: string,
    premio: string,
    proposta: string,
    sinistro: string,
    taxa: string,
    trabalhista: string,
    usuarioCriador: string,
    valor: number | undefined,
    valorComissao: number | undefined,
    valorExtenso: string,
    valorPago: number | undefined,
    valorSpread: number | undefined,
}


const RelatorioEmissao = (props: any) => {


    const [resultado, setResultado] = useState<iDados[]>([])
    const [carregando, setCarregando] = useState<string>('none')

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])
    //const [emissao_id, setEmissao_id] = useState<number | undefined>()

    const [tipo, setTipo] = useState<string>('')
    const [subtipo, setSubtipo] = useState<string>('')

    const [corretores, setCorretores] = useState<iCorretor[]>([])
    const [corretor_id, setCorretor_id] = useState<string>('') // '' = todos

    const today = new Date()


    const [startDate, setDate] = useState(new Date(today.getFullYear(), 0, 1));
    const [startDate2, setDate2] = useState(new Date());


    const selectDateHandler = (d: any) => {
        setDate(d)
    }


    const selectDateHandler2 = (d: any) => {
        setDate2(d)
    }


    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)


        }

    }, [dadosUsuarios])


    // lista de corretores da afiançadora (filtro do relatório "Por Corretor")
    useEffect(() => {

        setCorretor_id('')
        setCorretores([])

        if (tipo !== 'porCorretor' || !cliente_id) return

        api.post('corretorListaTodos', { cliente_id: cliente_id }).then((result) => {

            const lista: iCorretor[] = [...result.data].sort((a: iCorretor, b: iCorretor) =>
                nomeCorretor(a).localeCompare(nomeCorretor(b))
            )
            setCorretores(lista)

        }).catch((err) => {
            console.error(err)
            toast.error('Falha ao carregar corretores')
        })

    }, [tipo, cliente_id])


    const nomeCorretor = (c: iCorretor) =>
        (c.tipoJuridico == 'F' ? c.nome : (c.razaoSocial || c.nomeFantasia || c.nome)) ?? ''


    const consulta = async () => {

        if (!cliente_id) {
            toast.error('Selecione uma afiançadora')
            return false
        }

        if (tipo == '') {
            toast.error('Selecione o tipo do relatório')
            return false
        }

        if (subtipo == '') {
            toast.error('Selecione o subtipo do relatório')
            return false
        }

        setResultado([])
        setCarregando('block')

        const porCorretor = tipo == 'porCorretor'

        const endpoint = porCorretor ? `excelGarantiaPorCorretor` : `relEmissao`

        var dataPost: any = porCorretor
            ? {
                cliente_id: cliente_id,
                dataInicio: moment(startDate).format('DD-MM-YYYY'),
                dataFim: moment(startDate2).format('DD-MM-YYYY'),
                subtipo: subtipo,
                corretor_id: corretor_id ? Number(corretor_id) : null
            }
            : {
                cliente_id: cliente_id,
                dataInicio: moment(startDate).format('YYYY-MM-DD'),
                dataFim: moment(startDate2).format('YYYY-MM-DD'),
                tipo: tipo,
                subtipo: subtipo
            }



        try {
            const response = await api.post<Blob>(endpoint, dataPost, {
                responseType: "blob",
                validateStatus: (status) => true // para não cair direto no catch
            });

            if (response.status !== 200) {
                // ler como texto para ver o erro real
                const errorText = await response.data.text();
                console.error("Erro backend:", errorText);
                toast.error("Erro ao exportar: " + errorText);
                return;
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", porCorretor ? `relGarantiaPorCorretor.xlsx` : `relEmissoes.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success("Download concluído!");
        } catch (err) {
            console.error(err);
            toast.error("Falha ao baixar arquivo");
        }

    }


    const columns: MRT_ColumnDef<iDados>[] = [

        {
            accessorKey: 'pin',
            header: 'Pin',
            Cell: ({ renderedCellValue, row }) => (

                <Badge style={{ fontSize: '0.7rem' }} bg='warning'>{renderedCellValue}</Badge>

            ),

        },

        {
            accessorKey: 'dataEmissao',
            header: 'Emissão',


        },

        {
            accessorKey: 'dataInicio',
            header: 'Início',


        },


        {
            accessorKey: 'dataVencimento',
            header: 'Vencimento',


        },


        {
            accessorKey: 'valor',
            header: 'Valor',
            muiTableHeadCellProps: {
                align: 'right',
            },
            muiTableBodyCellProps: {
                align: 'right',
            },
            Cell: ({ cell }) => {
                const rawValue = cell.getValue();
                const strValue = typeof rawValue === 'string' ? rawValue : String(rawValue ?? '');

                const numberValue = parseFloat(
                    strValue.replace(/\./g, '').replace(',', '.')
                );

                return numberValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            },

            sortingFn: (rowA, rowB, columnId) => {
                const aRaw = rowA.getValue(columnId) as string;
                const bRaw = rowB.getValue(columnId) as string;

                const a = parseFloat(aRaw.replace(/\./g, '').replace(',', '.'));
                const b = parseFloat(bRaw.replace(/\./g, '').replace(',', '.'));

                return a - b;
            },
        },



        {
            accessorKey: 'valorComissao',
            header: 'Comissão',
            muiTableHeadCellProps: {
                align: 'right',
            },
            muiTableBodyCellProps: {
                align: 'right',
            },
            Cell: ({ cell }) => {
                const rawValue = cell.getValue();
                const strValue = typeof rawValue === 'string' ? rawValue : String(rawValue ?? '');

                const numberValue = parseFloat(
                    strValue.replace(/\./g, '').replace(',', '.')
                );

                return numberValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            },

            sortingFn: (rowA, rowB, columnId) => {
                const aRaw = rowA.getValue(columnId) as string;
                const bRaw = rowB.getValue(columnId) as string;

                const a = parseFloat(aRaw.replace(/\./g, '').replace(',', '.'));
                const b = parseFloat(bRaw.replace(/\./g, '').replace(',', '.'));

                return a - b;
            },
        },


        {
            accessorKey: 'valorPago',
            header: 'Pago',
            muiTableHeadCellProps: {
                align: 'right',
            },
            muiTableBodyCellProps: {
                align: 'right',
            },
            Cell: ({ cell }) => {
                const rawValue = cell.getValue();
                const strValue = typeof rawValue === 'string' ? rawValue : String(rawValue ?? '');

                const numberValue = parseFloat(
                    strValue.replace(/\./g, '').replace(',', '.')
                );

                return numberValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            },

            sortingFn: (rowA, rowB, columnId) => {
                const aRaw = rowA.getValue(columnId) as string;
                const bRaw = rowB.getValue(columnId) as string;

                const a = parseFloat(aRaw.replace(/\./g, '').replace(',', '.'));
                const b = parseFloat(bRaw.replace(/\./g, '').replace(',', '.'));

                return a - b;
            },
        },



        {
            accessorKey: 'valorSpread',
            header: 'Spread',
            muiTableHeadCellProps: {
                align: 'right',
            },
            muiTableBodyCellProps: {
                align: 'right',
            },
            Cell: ({ cell }) => {
                const rawValue = cell.getValue();
                const strValue = typeof rawValue === 'string' ? rawValue : String(rawValue ?? '');

                const numberValue = parseFloat(
                    strValue.replace(/\./g, '').replace(',', '.')
                );

                return numberValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            },

            sortingFn: (rowA, rowB, columnId) => {
                const aRaw = rowA.getValue(columnId) as string;
                const bRaw = rowB.getValue(columnId) as string;

                const a = parseFloat(aRaw.replace(/\./g, '').replace(',', '.'));
                const b = parseFloat(bRaw.replace(/\./g, '').replace(',', '.'));

                return a - b;
            },
        },





    ]



    return (

        <div>


            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Relatório</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">

                            <li className="breadcrumb-item active" aria-current="page">Emissão</li>
                        </ol>
                    </nav>
                </div>

            </div>

            <div className="row" >
                <div className="row g-3">
                    <div className="col-md-2">

                        <label className="form-label">Data início *</label>
                        <DatePicker
                            className="form-control"
                            locale={ptBR}

                            wrapperClassName="w-100"
                            dateFormat="dd/MM/yyyy"
                            selected={startDate}
                            onChange={selectDateHandler}
                            //minDate={today}
                            //maxDate={today}
                            customInput={

                                <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />

                            }
                        />

                    </div>
                    <div className="col-md-2">


                        <label className="form-label">Data término *</label>
                        <DatePicker
                            className="form-control"
                            locale={ptBR}

                            wrapperClassName="w-100"
                            dateFormat="dd/MM/yyyy"
                            selected={startDate2}
                            onChange={selectDateHandler2}
                            //maxDate={today}
                            customInput={

                                <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />

                            }
                        />


                    </div>
                    <div className="col-md-2">
                        <label className="form-label">Tipo *</label>
                        <select className="form-control" value={tipo} onChange={event => {
                            const novoTipo = event.target.value
                            setTipo(novoTipo)
                            // subtipos de "Por Corretor" são diferentes dos demais
                            if ((novoTipo === 'porCorretor') !== (tipo === 'porCorretor')) setSubtipo('')
                        }} >
                            <option value="">[Selecione]</option>
                            <option value="dataEmissao">Data Emissão</option>
                            <option value="ad_new">Data Criação</option>
                            <option value="ad_upd">Data Alteração</option>
                            <option value="vencida">Vencidas</option>
                            <option value="vigente">Vigentes</option>
                            <option value="pago">Pago</option>
                            <option value="aberto">Aberto</option>
                            <option value="trabalhista">Trabalhista</option>
                            <option value="fiscal">Fiscal</option>
                            <option value="multa">Multa</option>
                            <option value="porCorretor">Por Corretor</option>

                        </select>
                    </div>
                    <div className="col-md-2">
                        <label className="form-label">Subtipo *</label>
                        <select className="form-control" value={subtipo} onChange={event => setSubtipo(event.target.value)} >
                            <option value="">[Selecione]</option>
                            <option value="todos">Todos</option>
                            {tipo === 'porCorretor' ? (
                                <>
                                    <option value="pago">Pago</option>
                                    <option value="aberto">Aberto</option>
                                </>
                            ) : (
                                <>
                                    <option value="garantia">Garantia</option>
                                    <option value="minuta">Minuta</option>
                                    <option value="proposta">Proposta</option>
                                </>
                            )}


                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Afiançadora</label>
                        <select className="form-control" value={cliente_id} disabled={clientes.length > 1 ? false : true} onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)} >
                            {clientes.length > 1 && (<option value="">[Selecione]</option>)}

                            {

                                clientes.map((rs: iClientes) =>

                                    <option value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                                )

                            }

                        </select>
                    </div>

                    {tipo === 'porCorretor' && (
                        <div className="col-md-4">
                            <label className="form-label">Corretor</label>
                            <select className="form-control" value={corretor_id} onChange={event => setCorretor_id(event.target.value)} >
                                <option value="">[Todos]</option>

                                {

                                    corretores.map((rs: iCorretor) =>

                                        <option key={rs.corretor_id} value={rs.corretor_id}>{rs.tipoJuridico == 'F' ? rs.cpf : rs.cnpj} - {nomeCorretor(rs)}</option>
                                    )

                                }

                            </select>
                        </div>
                    )}



                </div>


                <div className="col-md-12" style={{ marginTop: 20, marginBottom: 20 }}>
                    <div className="d-md-flex d-grid align-items-center gap-2">

                        <button type="button" className="btn btn-info" onClick={consulta}>Ok</button>


                    </div>
                </div>


                {

                    /*


                    <div className="col-12 col-xl-12">
                        

                        <center>
                        <LoaderIcon.Puff stroke="#000" style={{ display: carregando }} />
                        </center>





                    </div>
                    <div className="col-lg-12" style={{ display: resultado.length > 0 ? 'block' : 'none'}}>

                        <MaterialReactTable

                        columns={columns}
                        data={resultado}
                        localization={MRT_Localization_PT_BR}
                        //rowsPerPage={20}
                        //options={options}
                        initialState={{ density: 'compact' }}
                        muiTableHeadCellProps={{
                            //easier way to create media queries, no useMediaQuery hook needed.
                            sx: {
                                fontSize: {
                                    xs: '8px',
                                    sm: '9px',
                                    md: '10px',
                                    lg: '11px',
                                    xl: '12px',
                                },
                            },
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                fontSize: {
                                    xs: '8px',
                                    sm: '9px',
                                    md: '10px',
                                    lg: '11px',
                                    xl: '12px',
                                },
                            },
                        }}
                        muiTableBodyRowProps={({ row }) => ({
                            onClick: () => {
                                
                            },
                            sx: {
                                cursor: 'auto', 
                            },
                        })}
                        />


                        </div>


                    */
                }


            </div>



        </div>

    )


}

export default RelatorioEmissao